// @flow
import React from 'react';
import {connect} from 'react-redux'
import AbstractReactComponent from './../AbstractReactComponent';
import {Input} from 'reactstrap';
import ApiObjectSuggestField from './../field/ApiObjectSuggestField';
import * as PravniFormyActions from "./../actions/pravniFormy-actions";
import {filterObjectsByPropertyFulltext} from "./../utils";
import {COMPONENT_CHILDREN} from './../Utils2';
import {storeFromArea} from "./../utils";

function getArea(props) {
    return props.area ? props.area : "shared.pravniFormy";
}

// TODO StoreSuggest
/**
 * Právní forma field
 * Suggest
 */
class PravniFormaField extends AbstractReactComponent {

    static PropTypes = {
        pravniFormy: React.PropTypes.object,    // není required kvůli shared store, který nemusí být inicializovaný
        area: React.PropTypes.string,
        addonsBefore: COMPONENT_CHILDREN,
        addonsAfter: COMPONENT_CHILDREN,
    };

    componentWillMount() {
        const area = getArea(this.props);
        this.dispatch(PravniFormyActions.fetchListIfNeeded(area));
    }

    handleFilterSuggestions = (value) => {
        const {pravniFormy} = this.props;

        return new Promise((resolve, reject) => {
            if (pravniFormy.fetched) {
                const rows = filterObjectsByPropertyFulltext(pravniFormy.rows, value, "nazev");
                resolve(rows);
            } else {
                resolve([]);
            }
        });
    };

    render() {
        const {pravniFormy, ...other} = this.props;

        if (!pravniFormy || !pravniFormy.fetched) {
            return <Input
                type="text"
                disabled={true}
            />
        }

        return <ApiObjectSuggestField
            dropdown={true}
            filterSuggestions={this.handleFilterSuggestions}
            apiRequestDelay={0}
            getItemValue={(item) => item ? item.nazev : ""}
            renderSuggestion={(i, active, getItemValue) => <div
                className={active ? "active" : ""}>{i.nazev}</div>}
            {...other}
        />;
    }
}

function mapStateToProps(state, props) {
    const useArea = getArea(props);
    const pravniFormyStore = storeFromArea(state, useArea, false);

    return {
        pravniFormy: pravniFormyStore,
    };
}

export default connect(mapStateToProps)(PravniFormaField);
